<template>
  <div class="sidebar-wrap">

    <section class="activities-realtime activities-realtime--visitors"
      :class="{ 'scrollmagic__realtime-fade-in-up': !$firefox }"
    >
      <div class="activities-realtime__container">
        <h2 class="activities-realtime__title">Visitors</h2>

        <template v-if="visitors !== null">
          <div class="activities-realtime-columns activities-realtime-columns--double">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--50">{{ abbreviateNumber(visitors, 0) }}</p>
                <small class="activities-realtime__info">Visitors Right Now</small>
              </li>
              <li class="activities-realtime__item">
                <simple-bar-chart
                  :chartData="{datasets: visitors_history.datasets}"
                  :options="{responsive: false, maintainAspectRatio: false}"
                  :width="90"
                  :height="65"/>
              </li>
            </ul>
          </div>

          <!-- <div class="activities-realtime-columns activities-realtime-columns--triple">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item"
                v-for="(value, key) in visitorTypes"
                :key="key"
              >
                <p class="activities-realtime__result activities-realtime__result--20">{{ value }}</p>
                <small class="activities-realtime__info">{{ key == 'new' ? 'First Time Visitors' : 'Returning Customers' }}</small>
              </li>
            </ul>
          </div> -->
        </template>
        <template v-else-if="googleIntegrated === false">
          <placeholder type="google"></placeholder>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <section class="activities-realtime activities-realtime--carts"
      :class="{ 'scrollmagic__realtime-fade-in-up': !$firefox }"
    >
      <div class="activities-realtime__container">
        <h2 class="activities-realtime__title">Carts</h2>

        <template v-if="carts !== null">
          <div class="activities-realtime-columns activities-realtime-columns--single">
            <p class="activities-realtime__result activities-realtime__result--28">
              <i-count-up
                :start="0"
                :end="number(carts.total_price)"
                :decimals="2"
                :duration="1"
                :options="{prefix: $currency}"
              ></i-count-up>
            </p>
            <small class="activities-realtime__info">Total Value of Active Carts</small>
          </div>

          <div class="activities-realtime-columns activities-realtime-columns--single">
            <p class="activities-realtime__result activities-realtime__result--20">
              <i-count-up
                :start="0"
                :end="cartAverage()"
                :decimals="2"
                :duration="1"
                :options="{prefix: $currency}"
              ></i-count-up>
            </p>
            <small class="activities-realtime__info">Average Cart Value</small>
          </div>

          <div class="activities-realtime-columns activities-realtime-columns--double">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--20">
                  <i-count-up
                    :start="0"
                    :end="carts.count"
                    :duration="1"
                  ></i-count-up>
                </p>
                <small class="activities-realtime__info">Currently Active Carts</small>
              </li>
              <!-- <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--20">27</p>
                <small class="activities-realtime__info">Returning Customers</small>
              </li> -->
            </ul>
          </div>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <section class="activities-realtime activities-realtime--checkout"
      :class="{ 'scrollmagic__realtime-fade-in-up': !$firefox }"
    >
      <div class="activities-realtime__container">
        <h2 class="activities-realtime__title">Checkout</h2>

        <template v-if="checkouts !== null">
          <div class="activities-realtime-columns activities-realtime-columns--double">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--50">{{ abbreviateNumber(checkouts.count, 0) }}</p>
                <small class="activities-realtime__info">Visitors in Checkout</small>
              </li>
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--20">
                  <i-count-up
                    :start="0"
                    :end="number(checkouts.total_price)"
                    :decimals="2"
                    :duration="1"
                    :options="{prefix: $currency}"
                  ></i-count-up>
                </p>
                <small class="activities-realtime__info">In Checkout Value</small>
              </li>
            </ul>
          </div>

          <div class="activities-realtime-columns activities-realtime-columns--triple">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--20">{{ number(checkouts.info_count) }}</p>
                <small class="activities-realtime__info">In Info</small>
              </li>
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--20">{{ number(checkouts.shipping_count) }}</p>
                <small class="activities-realtime__info">In Shipping</small>
              </li>
              <li class="activities-realtime__item">
                <p class="activities-realtime__result activities-realtime__result--20">{{ number(checkouts.billing_count) }}</p>
                <small class="activities-realtime__info">In Payment</small>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <section class="activities-realtime activities-realtime--traffic"
      :class="{ 'scrollmagic__realtime-fade-in-up': !$firefox }"
    >
      <div class="activities-realtime__container">
        <h2 class="activities-realtime__title">Traffic Source</h2>

        <template v-if="trafficMediums !== null">
          <div class="activities-realtime-columns activities-realtime-columns--double">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item">
                <i class="activities-realtime__icon icon--search"></i>
                <span class="activities-realtime__icon-info">
                  <p class="activities-realtime__result activities-realtime__result--20">
                    <i-count-up
                      :start="0"
                      :end="visitorPercentage(trafficMediums.search)"
                      :duration="1"
                      :options="{suffix: '%'}"
                    ></i-count-up>
                  </p>
                  <small class="activities-realtime__info">Search</small>
                </span>
              </li>
              <li class="activities-realtime__item">
                <i class="activities-realtime__icon icon--mail"></i>
                <span class="activities-realtime__icon-info">
                  <p class="activities-realtime__result activities-realtime__result--20">
                    <i-count-up
                      :start="0"
                      :end="visitorPercentage(trafficMediums.email)"
                      :duration="1"
                      :options="{suffix: '%'}"
                    ></i-count-up>
                  </p>
                  <small class="activities-realtime__info">Email</small>
                </span>
              </li>
            </ul>
          </div>

          <div class="activities-realtime-columns activities-realtime-columns--double">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item">
                <i class="activities-realtime__icon icon--network"></i>
                <span class="activities-realtime__icon-info">
                  <p class="activities-realtime__result activities-realtime__result--20">
                    <i-count-up
                      :start="0"
                      :end="visitorPercentage(trafficMediums.social)"
                      :duration="1"
                      :options="{suffix: '%'}"
                    ></i-count-up>
                  </p>
                  <small class="activities-realtime__info">Social</small>
                </span>
              </li>
              <li class="activities-realtime__item">
                <i class="activities-realtime__icon icon--currency-dollar"></i>
                <span class="activities-realtime__icon-info">
                  <p class="activities-realtime__result activities-realtime__result--20">
                    <i-count-up
                      :start="0"
                      :end="visitorPercentage(trafficMediums.paid)"
                      :duration="1"
                      :options="{suffix: '%'}"
                    ></i-count-up>
                  </p>
                  <small class="activities-realtime__info">Paid</small>
                </span>
              </li>
            </ul>
          </div>
        </template>
        <template v-else-if="googleIntegrated === false">
          <placeholder type="google"></placeholder>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <section class="activities-realtime activities-realtime--device"
      :class="{ 'scrollmagic__realtime-fade-in-up': !$firefox }"
    >
      <div class="activities-realtime__container">
        <h2 class="activities-realtime__title">Device Type</h2>

        <template v-if="deviceTypes !== null">
          <div class="activities-realtime-columns activities-realtime-columns--triple">
            <ul class="activities-realtime__list">
              <li class="activities-realtime__item"
                v-for="(value, key) in deviceTypes"
                :key="key"
              >
                <i class="activities-realtime__icon"
                  :class="'icon--device-' + key"
                ></i>
                <p class="activities-realtime__result activities-realtime__result--19">
                  <i-count-up
                    :start="0"
                    :end="visitorPercentage(value)"
                    :duration="1"
                    :options="{suffix: '%'}"
                  ></i-count-up>
                </p>
                <small class="activities-realtime__info">{{ capitalizeFirstLetter(key.toLowerCase()) }}</small>
              </li>
            </ul>
          </div>
        </template>
        <template v-else-if="googleIntegrated === false">
          <placeholder type="google"></placeholder>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

  </div>
</template>

<script>
  import SimpleBarChart from '@/components/charts/SimpleBarChart'

  import { ga } from '@/mixins/ga.js'
  import { helpers } from '@/mixins/helpers.js'
  import { refresh } from '@/mixins/refresh.js'

  import axios from 'axios'
  import ICountUp from 'vue-countup-v2'
  import ifvisible from 'ifvisible.js'
  import ScrollMagic from 'scrollmagic'
  // import 'debug.addIndicators' // Debug tool for scrollmagic
  import Vue from 'vue'

  let Placeholder = Vue.component('placeholder', {
    props: {
      type: {
        default: 'placeholder',
        type: String
      }
    },
    template: `
      <div class="activities-realtime-placeholder">
        <template v-if="type == 'placeholder'">
          <span class="placehold placehold--height-20 placehold--margin-bottom-9 placehold--width-30-percent"></span>
          <span class="placehold placehold--height-5 placehold--margin-bottom-30 placehold--width-60-percent"></span>
          <span class="placehold placehold--height-20 placehold--margin-bottom-9 placehold--width-30-percent"></span>
          <span class="placehold placehold--height-5 placehold--margin-bottom-30 placehold--width-50-percent"></span>
          <span class="placehold placehold--height-20 placehold--margin-bottom-9 placehold--width-30-percent"></span>
          <span class="placehold placehold--height-5 placehold--width-40-percent"></span>
        </template>
        <template v-else>
          <p class="activities-realtime-placeholder__alert">You must setup Google Analytics to view this information.</p>
        </template>
      </div>
    `
  })

  export default {
    name: 'realTimeSidebar',
    components: {
      'i-count-up': ICountUp,
      'placeholder': Placeholder,
      'simple-bar-chart': SimpleBarChart
    },
    mixins: [ga, helpers, refresh],
    data () {
      return {
        carts: null,
        checkouts: null,
        googleIntegrated: null,
        scrollMagicProgress: null,
        sidebarController: null,
        visitors_history: {
          datasets: [
            {data: [0]}, {data: [0]}, {data: [0]}, {data: [0]}, {data: [0]},
            {data: [0]}, {data: [0]}, {data: [0]}, {data: [0]}, {data: [0]}
          ]
        }
      }
    },
    methods: {
      applyRealtimeVisitorsChart () {
        this.visitors_history.datasets.push({
          data: [this.visitors],
          backgroundColor: '#4459fb'
        })
        this.visitors_history.datasets = this.visitors_history.datasets.slice(-10)
        this.scrollMagicFadeInUpdate()
        this.$emit('updateIScroll')
      },
      cartAverage () {
        if (this.carts.count < 1) return 0
        return this.carts.total_price / this.carts.count
      },
      loadData (force = false) {
        if (force || this.isActive()) {
          this.loadGoogleData()
          this.loadPlatformData()
        }
      },
      isActive () {
        let html = document.querySelector('html')
        let realtimeActive = html.classList.contains('realtime-active')
        let todayActive = html.classList.contains('today-active')

        return ifvisible.now() && (realtimeActive || (this.getBreakpoint() >= 1200 && !todayActive))
      },
      loadGoogleData () {
        // Get google analytics realtime data
        let that = this

        return axios({
          method: 'get',
          url: `integration/google/analytics/${that.$domain}/realtime`
        })
        .then((response) => {
          that.deviceTypes = that.getDeviceTypes(response.data, 'active_users')
          that.visitorTypes = that.getRealtimeVisitorTypes(response.data)
          that.trafficMediums = that.getTrafficMediums(response.data)
          that.visitors = that.getRealtimeVisitors(response.data)
          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
          that.applyRealtimeVisitorsChart()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadPlatformData () {
        // Get platform realtime data
        let that = this

        return axios({
          method: 'get',
          url: `${that.$domain}/report/realtime`
        })
        .then((response) => {
          that.carts = response.data.carts
          that.checkouts = response.data.checkouts
          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
        })
        .catch((error) => {
          console.log(error)
        })
      },
      scrollMagicFadeIn () {
        if (this.$firefox === false) {
          Vue.nextTick(() => {
            let fadeElements = document.querySelectorAll('.scrollmagic__realtime-fade-in-up')
            let html = document.querySelector('html')

            this.scrollMagicProgress = null

            if (this.sidebarController === null) {
              this.sidebarController = new ScrollMagic.Controller()

              for (let fadeElement of fadeElements) {
                let scene = new ScrollMagic.Scene({ // eslint-disable-line no-unused-vars
                  triggerElement: fadeElement,
                  triggerHook: 0.9,
                  reverse: false
                })
                .setClassToggle(fadeElement, 'scrollmagic__realtime-fade-in-up--show')
                // .addIndicators() // Debug tool for scrollmagic
                .addTo(this.sidebarController)

                this.scrollMagicProgress = scene.progress()
              }
            }

            if (html.classList.contains('scrollmagic-realtime-loading')) {
              html.classList.remove('scrollmagic-realtime-loading')
            }
          })
        }
      },
      scrollMagicFadeInDestroy () {
        if (this.$firefox === false) {
          if (this.sidebarController !== null) {
            let items = this.$el.querySelectorAll('.scrollmagic__realtime-fade-in-up')

            for (let item of items) {
              if (item.classList.contains('scrollmagic__realtime-fade-in-up--show')) {
                item.classList.remove('scrollmagic__realtime-fade-in-up', 'scrollmagic__realtime-fade-in-up--show')
              }
            }

            this.sidebarController.destroy(true)
            this.sidebarController = null
          }
        }
      },
      scrollMagicFadeInUpdate () {
        if (this.$firefox === false) {
          let items = this.$el.querySelectorAll('.scrollmagic__realtime-fade-in-up')

          if (items.length > 0) {
            this.scrollMagicFadeInDestroy()

            let scrollMagicReady = setInterval(() => {
              this.scrollMagicFadeIn()

              if (this.scrollMagicProgress !== null) {
                clearInterval(scrollMagicReady)
              }
            }, 100)
          }
        }
      }
    },
    mounted () {
      window.addEventListener('load', () => {
        this.scrollMagicFadeIn()
      })
    },
    created () {
      this.loadData()

      if (this.$firefox === false) {
        document.querySelector('html').classList.add('scrollmagic-realtime-loading')
      }

      this.$parent.$on('googleIntegrated', (boolean) => {
        this.googleIntegrated = boolean
        this.scrollMagicFadeInUpdate()
        this.$emit('updateIScroll')
      })
    },
    watch: {
      '$parent.navigationActive': function () {
        if (this.$parent.navigationActive === 'realtime') {
          this.loadData(true)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/RealTimeSidebar.vue